module.exports = __webpack_public_path__ + "media/images/flags/16/Nagorno-Karabakh-9a5a00b982a3e6185c642765842ae685.png";